<template><svg  viewBox="0 0 427 118" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.385538" y1="5.07731" x2="213.386" y2="94.0773" stroke="#292D32" stroke-width="2"/>
<line x1="221.604" y1="94.5452" x2="426.604" y2="6.08196" stroke="#292D32" stroke-width="2"/>
<circle cx="218" cy="82" r="36" fill="#1E0C12"/>
<circle cx="218.5" cy="81.5" r="24.5" stroke="#292D32" stroke-width="2"/>
<rect x="213" y="70" width="11" height="42" fill="#292D32"/>
</svg>
</template>